import React, { useEffect, useRef, useState } from "react";
import Header from "../../../components/global/Header";
import LeftNavbar from "../../../components/global/LeftNavbar";
import { Link, useNavigate } from "react-router-dom";
import {  useTranslation } from 'react-i18next';
import Select from 'react-select';
import { deleteAxiosResponse, getAxiosResponse, postAxiosResponse, putAxiosResponse, putOrPostAxiosResponse } from "../../../services/authApiRoutes/APImethods";
import { updateTreeValue, updateTab, updateTreeData, addChildrenToTreeData, resetTree, setSelectedTreeData, addToSelectedTreeData, removeFromSelectedTreeData, updateSelectedTreeNode } from "../../../redux/reducers/TreeSlice";
import APIUrls from "../../../services/APIUrls";
import { dateConvertToTimeStamp, transformBlankToNull, isValidHttpUrl } from '../../../services/Util';
import Constants from "../../../Constants";
import DataTable, { createTheme } from "react-data-table-component";
import jQuery from "jquery";
import BackToSetting from "../BackToSetting"
import UserPermissionsSetting from "./UserPermissionsSetting"
import {getSettings} from "./IntegrationSettingsUtil"
import TreeView from '../../TreeView'
import { useSelector, useDispatch } from "react-redux";
import { RotatingLines } from "react-loader-spinner";
import SuccessMessage from "../../../components/SuccessMessage";
import EloquaCredential from "./EloquaCredential";
import { getLoggedInUserRole } from "../../../services/Util";
import { Breadcrumb } from "../../../components/dashboard/Breadcrumb";
import $ from "jquery";
import { logError } from "../../../services/authApiRoutes/APImethods";
import { handleError } from "../../../services/authApiRoutes/APImethods";
import { ConditionalBlock } from "../../../ConditionalBlock";

export default function EloquaIntegrationSetting() {
  const scrollRef = useRef(null);
  const navigate = useNavigate();
  const searchContactRef = useRef(null);
  const assetTypeRef = useRef(null);
  const sourceAssetIndexRef = useRef(null);
  const targetAssetIndexRef = useRef(null);
  const selectedContactRef = useRef(null);
  const errorMessageRef = useRef({assetTypeError:null, assetNameError:null, sourceLanguageError:null, targetLanguageError:null})
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const translate = t;
  const aaaSelected = useSelector((aaaChecked) => aaaChecked.contrast).value;
  const theme = aaaSelected ? "dark" : "";
  const UserPermissionsSettingMemo = React.memo(UserPermissionsSetting);
  const TreeViewMemo = React.memo(TreeView);
  const EloquaCredentialMemo = React.memo(EloquaCredential);
  const [permissionStatus,setPermissionStatus]=useState(false)

  const showModel = () => {
    document.body.classList.add("modal-open");
  };
  const hideCredentialModel = () => {
    document.body.classList.remove("modal-open");
  };
  const hideModel = () => {
    jQuery("#addAsset").trigger('focus')
    document.body.classList.remove("modal-open");
  };
  const showContactModel = () => {
    setShowContactPopup(true);
    document.body.classList.add("modal-open");
  };
  const hideContactModel = () => {
    setShowContactPopup(false);
    document.body.classList.remove("modal-open");
  };
  
  const [departments, setDepartments] = useState([]);
  const [preference, setPreference] = useState();
  const [deptPreference, setDeptPreference] = useState({});
  const [settings, setSettings] = useState([]);
  const [pendingPermission, setPendingPermission] = useState(false);
  const [pendingDeptSettings, setPendingDeptSettings] = useState(false);
  const [credentialData, setCredentialData] = useState({});
  const [orgPreferences, setOrgPreferences] = useState();
  const [contact, setContact] = useState();
  const [contacts, setContacts] = useState([]);
  const [pendingContacts, setPendingContacts] = useState(false);
  const [showContactPopup, setShowContactPopup] = useState(false);
  const [sourceLanguages, setSourceLanguages] = useState([]);
  const [sourceLanguageOptions, setSourceLanguageOptions] = useState([]);
  const [targetLanguages, setTargetLanguages] = useState([]);
  const [targetLanguageOptions, setTargetLanguageOptions] = useState([]);
  const [preConfiguredMappings, setPreConfiguredMappings] = useState([]);
  const [credentialErrorMessage, setCredentialErrorMessage] = useState({});
  const [isValidating, setValidating] = useState(false);
  const [integrationUsers, setIntegrationUsers] = useState([]);
  const [headerOrFooterAssets, setHeaderOrFooterAssets] = useState([]);
  const [showHeaderFooterTree, setShowHeaderFooterTree] = useState(false);
  const [checked, setchecked] = useState(false);
  const [childData, setChildData] = useState();
  const [successMessage, setSuccessMessage] = useState(Constants.BLANK);
  const [serverErrorMessage, setServerErrorMessage] = useState([]);
  const [mappingErrorMessage, setMappingErrorMessage] = useState({assetTypeError:null, assetNameError:null, sourceLanguageError:null, targetLanguageError:null})
  const [enableCredential, setEnableCredential] = useState(false);
  const [user, setUser] = useState();

  const roleArray = getLoggedInUserRole();
  const sourceMappingRowsDefault = 1;
  const targetMappingRowsDefault = 3;
  const blankRuleValue = { contentType: "ELOQUA", language: null, assetType: null , targetLanguageError:null};

  const treeValueRedux = useSelector((redux) => redux.tree_structure).treeValue;
  const selectedTreeData = useSelector(redux => redux.tree_structure).selectedTreeData
  const dispatchDataToTreeSliceRedux = (type, value) => {		
		dispatch(updateTreeValue({
		  type: type,
		  value: value
		}));
	}

  const assetTypeOptions = [
    //{ value: '', label: 'Select Asset Type' },
    { value: 'EMAIL_HEADER', label: 'Email Header' },
    { value: 'EMAIL_FOOTER', label: 'Email Footer' }
  ];

  useEffect(()=>{
    $(".lastdisable").trigger("focus");
  }, [])
  
  const deptSettingsColumns = [
    {
      id: "setting.name",
      name: "Department",
      maxWidth: "3300px",
      selector: (setting) => setting.userGroup,
      sortable: true,
      cell: (setting) => setting.userGroup.name
    },
    {
      id: "setting.dependencies",
      name: "Default include dependencies checkbox behavior (on/off)",
      maxWidth: "350px",
      wrap: true,
      subHeaderWrap:true,
      center: true,
      align: "right",
      selector: (setting) => setting.ELOQUA_DEFAULT_INCLUDE_DEPENDENCIES_CHECKBOX,
      cell: (setting) => (
        <div className="form-check">
            <input className="form-check-input integration-setting" type="checkbox" name="checkbox" id={"dependencies-" +setting.userGroup.id} 
            data-group={setting.userGroup.id} data-pref="ELOQUA_DEFAULT_INCLUDE_DEPENDENCIES_CHECKBOX" checked={setting.ELOQUA_DEFAULT_INCLUDE_DEPENDENCIES_CHECKBOX == 'true'} 
            onChange={(e) => updatePreference(e)} />
            <label className="form-check-label" aria-label="checkbox" for={"dependencies-" +setting.userGroup.id}>&nbsp;</label>
        </div>
      )
    }
  ];

  const contactColumns = [
    {
      id: "contact.emailAddress",
      name: "Email Address",
      maxWidth: "350px",
      selector: (contact) => contact.emailAddress,
      sortable: true,
      cell: (contact) => contact.emailAddress
    },
    {
      id: "contact.firstName",
      name: "First Name",
      maxWidth: "350px",
      selector: (contact) => contact.firstName,
      sortable: true,
      cell: (contact) => contact.firstName
    },
    {
      id: "contact.lastName",
      name: "Last Name",
      maxWidth: "350px",
      selector: (contact) => contact.lastName,
      sortable: true,
      cell: (contact) => contact.lastName
    }
  ]

  useEffect(() => {
    //reset Tree on page load
    dispatch(resetTree())

    getPreference();
    getIntegrationusers();
    getDepartmentPreference();
    getAllDepartments();
    getUser();
    //getCredential();
    getContact();
    getOrgPreferences();
    getPreConfiguredMapping();
    getSourceLanguages();
    getTargetLanguages();
  }, [])

  useEffect(() => {
    if (deptPreference && Object.keys(deptPreference).length > 0 && departments.length > 0) {
      setSettings(getSettings(deptPreference, departments));
      setPendingDeptSettings(false);
    }
  }, [deptPreference, departments])

  useEffect(() => {
    dispatch(updateTreeData(headerOrFooterAssets))  
  }, [headerOrFooterAssets])

  useEffect(() => {
    if (user?.permissions[Constants.ELOQUA_ACCESS] === true) {
      getCredential();
    }
  }, [user])

  useEffect(()=>{
    if(successMessage!==Constants.BLANK){
      setSuccessMessage(successMessage);
      setTimeout(function(){
        setSuccessMessage(Constants.BLANK);
      },5000);
    }
  },[successMessage]);

  const getUser = () => {    
    const dateTimestamp = dateConvertToTimeStamp();
    getAxiosResponse(APIUrls.FULL_USER + `?_=${dateTimestamp}`
		).then(res => {
      if (res.data.code === 200) {
			  let user = transformBlankToNull(res.data.data);
        setUser(user)
      }
		})
  }

  const getPreference = () => {
    const dateTimestamp = dateConvertToTimeStamp();
    getAxiosResponse(
      APIUrls.CUSTOMER_ORG_PREFERENCE + `?preference=ENABLE_ELOQUA_INTEGRATION&_=${dateTimestamp}`
      ).then((res) => {
        if (res.data.code === 200) {
          setPreference(res?.data?.data?.status);
        }
      }).catch((err) => {
        handleError(err);
    });
  }

  const getDepartmentPreference = () => {
    setPendingDeptSettings(true);
    const dateTimestamp = dateConvertToTimeStamp();
    getAxiosResponse(
      APIUrls.CUSTOMER_DEPARTMENT_PREFERENCE_ALL + `?_=${dateTimestamp}`
      ).then((res) => {
        if (res.data.code === 200) {
          setDeptPreference(res.data.data)
        }
      }).catch((err) => {
        handleError(err);
    });
  }

  const getAllDepartments = () => {
    setPendingDeptSettings(true);
    const dateTimestamp = dateConvertToTimeStamp();
    getAxiosResponse(
      APIUrls.DEPARTMENT_INCLUDE_SYSTEM_IF_POPULATED + `?_=${dateTimestamp}`
      ).then((res) => {
        if (res.data.code === 200) {
          setDepartments(res.data.data)
        }
      }).catch((err) => {
        handleError(err);
    });
  }

  const getOrgPreferences = () => {
    const dateTimestamp = dateConvertToTimeStamp();
    getAxiosResponse(APIUrls.CUSTOMER_ORG_PREFERENCE_ALL + `?_=${dateTimestamp}`
    ).then (res => {
      if (res.data.code === 200) {
        var orgPreferences = transformBlankToNull(res.data.data)
        setOrgPreferences(orgPreferences)
      }
    }).catch(err => {
      handleError(err);
    });
  }

  const getCredential = () => {
    const dateTimestamp = dateConvertToTimeStamp();
    getAxiosResponse(APIUrls.CUSTOMER_EXTERNAL_SERVICE_CREDENTIALS(Constants.ELOQUA) + `?_=${dateTimestamp}`
    ).then (res => {
      if (res.data.code === 200) {
        var credentialsSet = transformBlankToNull(res.data.data.body)
        setCredentialData(credentialsSet)
      }
    }).catch(err => {
      handleError(err);
    });   
  };

  const getContact = () => {
    const dateTimestamp = dateConvertToTimeStamp();
    getAxiosResponse(APIUrls.ELOQUA_DEFAULT_CONTACT + `?_=${dateTimestamp}`
    ).then (res => {
      if (res.data.code === 200) {
        var contact = transformBlankToNull(res.data.data)
        setContact(contact)
      }
    }).catch(err => {
      handleError(err);
    });
  }

  const getSourceLanguages = () => {
    let langArray = [];
    const dateTimestamp = dateConvertToTimeStamp();
    getAxiosResponse(APIUrls.GET_ACCOUNT_SOURCE_LANGUAGES + `?_=${dateTimestamp}`
    ).then(res => {
        if (res.data.code === 200) {
          let languages = res.data.data;
          setSourceLanguages(languages);
          //langArray.push({ value: "", label: "Select Source Language" })
          languages.map(lang => {
            langArray.push({ value: lang.code, label: lang.display, language: lang.language })
          })
          setSourceLanguageOptions(langArray);
        } 
      }).catch(err => {
        handleError(err);
      });
  }

  const getTargetLanguages = () => {
    let langArray = [];
    const dateTimestamp = dateConvertToTimeStamp();
    getAxiosResponse(APIUrls.GET_ACCOUNT_TARGET_LANGUAGES + `?_=${dateTimestamp}`
    ).then(res => {
      if (res.data.code === 200) {
        let languages = res.data.data;
        setTargetLanguages(languages);
        //langArray.push({ value: "", label: "Select Target Language" })
        languages.map(lang => {
          langArray.push({ value: lang.code, label: lang.display, language: lang.language })
        })
        setTargetLanguageOptions(langArray);
      } 
    }).catch(err => {
      handleError(err);
    });
  }

  const getPreConfiguredMapping = () => {
    const dateTimestamp = dateConvertToTimeStamp();
    getAxiosResponse(APIUrls.ELOQUA_PRECONFIGURED_ASSET_MAPPING + `?_=${dateTimestamp}`
    ).then (res => {
      if (res.data.code === 200) {
        var preConfiguredMappings = transformBlankToNull(res.data.data)
        preConfiguredMappings?.map(mapping => {
          mapping.error = {assetTypeError:null, assetNameError:null, sourceLanguageError:null, targetLanguageError:null};
        })
        setPreConfiguredMappings(preConfiguredMappings)
      }
    }).catch(err => {
      handleError(err);
    });
  }

  const getIntegrationusers = () => {
    setPendingPermission(true);
    const dateTimestamp = dateConvertToTimeStamp();
    getAxiosResponse(
      APIUrls.CUSTOMER_INTEGRATION_USERS + `?_=${dateTimestamp}`
      ).then((res) => {
        setPendingPermission(false);
        if (res.data.code === 200) {
          let integrationUsers = transformBlankToNull(res.data.data);
          setIntegrationUsers(integrationUsers);
        }
      }).catch((err) => {
        handleError(err);
    });
  }

  const getHeaderOrFooterAssets = (folderId, searchString, setValue) => {
    const dateTimestamp = dateConvertToTimeStamp();
    let assetType = assetTypeRef.current?.code ? assetTypeRef.current?.code : assetTypeRef.current
    let urlString;
    if(assetType === Constants.EMAIL_HEADER) {
      urlString = APIUrls.ELOQUA_EMAIL_HEADER_ASSETS
    } else if (assetType === Constants.EMAIL_FOOTER){
      urlString = APIUrls.ELOQUA_EMAIL_FOOTER_ASSETS
    }
    urlString += searchString?.length > 0 ? `?search=${searchString}` : `?folderId=${folderId}`
    urlString += `&_=${dateTimestamp}`
    if (urlString.includes("undefined")) {
      return;
    }
    getAxiosResponse(urlString
      ).then((res) => {
        dispatchDataToTreeSliceRedux("isTreeLoading", false);
        if (res.data.code === 200) {
          let headerOrFooterAssets = transformBlankToNull(res.data.data.body.elements);
          setValue(headerOrFooterAssets)
        }
      }).catch((err) => {
        handleError(err);
    });
  }

  const updatePreference = (e) => {
    let el = jQuery(e.target);
    let userGroupId = el.attr('data-group');
    let dataPref = el.attr('data-pref');
    let value = "" + el.is(':checked');
    
    let localDeptPreference = JSON.parse(JSON.stringify(deptPreference));
    Object.entries(localDeptPreference).map(([deptId, prefs]) => {
      if (deptId === userGroupId) {
        let pref = prefs.find(pref => {
          return pref.preference === dataPref
        })
        pref.status = value;
      }
    })
    postAxiosResponse(
      APIUrls.CUSTOMER_DEPARTMENT_PREFERENCE_ALL, localDeptPreference
    ).then((res) => {
      if (res.data.code === 200) {
        setDeptPreference(res.data.data)
      } 
    }).catch((err) => {
      handleError(err);
    })
  }

  const clearContact = (e) => {
    deleteAxiosResponse(APIUrls.ELOQUA_DEFAULT_CONTACT)
    setContact(null);
  }

  const onContactSelect = ({ selectedRows }) => {
    selectedContactRef.current = selectedRows[0]
  };

  const saveSelectedContact = () => {
    postAxiosResponse(
      APIUrls.ELOQUA_DEFAULT_CONTACT + `?id=${selectedContactRef.current.id}&emailAddress=${selectedContactRef.current.emailAddress}`
    ).then(res => {
      hideContactModel();
      setContact(selectedContactRef?.current);
      setchecked(true);
    }).catch(err => {
      handleError(err)
    })
  }

  const addAssetRow = () => {
    setPreConfiguredMappings([...preConfiguredMappings, ...generateEmptyMappingRows(true)]);
  }
  const handleAddAssetClick = () => {
    if (preference === "true" && permissionStatus === true && !(isValidating)) {
      addAssetRow();
    } else {
      setSuccessMessage(translate("other_integrations_project_creation.eloqua_permissions_message"));
    }
  };
  const handleSelectContactClick = () => {
    if (preference === "true" && permissionStatus === true && !(isValidating)) {
      showContactModel();
    } else {
      setSuccessMessage(translate("other_integrations_project_creation.eloqua_permissions_message"));
    }
  };

  const addMoreTargetLanguages = (e) => {
    let index = jQuery(e.currentTarget).attr("data-index");
    let localAssetMappings = JSON.parse(JSON.stringify(preConfiguredMappings))
    let sourceSelection = localAssetMappings[index];
    if (index && sourceSelection?.assetType) {
      let emptyRows = generateEmptyMappingRows(false);
      sourceSelection?.targetAssetMappings.push(...emptyRows);
    }
    setPreConfiguredMappings(localAssetMappings)
  }

  const generateEmptyMappingRows = (generateEmptyRowsForSource) => {
    let blankTargetRows = [];
    for (var i = 0; i < targetMappingRowsDefault; i++) {
      blankTargetRows[i] = jQuery.extend(true, {}, blankRuleValue);
    }
    let blankRows = [];
    for (var i = 0; i < sourceMappingRowsDefault; i++) {
      blankRows[i] = jQuery.extend(true, { "targetAssetMappings": blankTargetRows }, blankRuleValue);
    }
    return generateEmptyRowsForSource ? blankRows : blankTargetRows;
  }

  const onChangeAssetType = (event, index) => {
      if(preConfiguredMappings?.length > 0) {
        preConfiguredMappings.map((mapping, index) => {
            mapping.error = {assetTypeError: '', assetNameError: 'Asset is not selected.', sourceLanguageError: '', targetLanguageError: ''}
          }
       )}
    let localMappings = JSON.parse(JSON.stringify(preConfiguredMappings));
    let sourceSelection = localMappings[index];
    sourceSelection.assetType = event.value //{ "code": event.value, "display": event.label }
    sourceSelection.sourceAssetMapping = {}
    sourceSelection.targetAssetMappings = generateEmptyMappingRows(false)
    sourceSelection.language = null
    sourceSelection.externalId = null
    sourceSelection.name=null
    sourceSelection.id = null
    setPreConfiguredMappings(localMappings);
  }

  const onChangeSourceLanguage = (event, index) => {
    if(preConfiguredMappings?.length > 0) {
      preConfiguredMappings.map((mapping, index) => {
          mapping.error = {assetTypeError: '', assetNameError: '', sourceLanguageError: '', targetLanguageError: ''}
        }
     )}
    let localMappings = JSON.parse(JSON.stringify(preConfiguredMappings));
    let sourceSelection = localMappings[index];
    sourceSelection.language = event.language
    setPreConfiguredMappings(localMappings);
  }

  const onChangeTargetLanguage = (event, index, targetLangIndex) => {
    if(preConfiguredMappings?.length > 0) {
      preConfiguredMappings.map((mapping, index) => {
        mapping.targetAssetMappings.map((targetMapping, targetLangIndex) => {
          targetMapping.targetLanguageError='';
        } 
        )})}
  
    let localMappings = JSON.parse(JSON.stringify(preConfiguredMappings));
    let sourceSelection = localMappings[index];
    sourceSelection.targetAssetMappings[targetLangIndex].language = event.language
    sourceSelection.targetAssetMappings[targetLangIndex].assetType = sourceSelection.assetType
    setPreConfiguredMappings(localMappings);
  }
  const removeAssetRow = (e) => {
    let index = jQuery(e.currentTarget).attr("data-index");
    setPreConfiguredMappings(preConfiguredMappings.filter(mapping => mapping !== preConfiguredMappings[index]))
  }

  const removeTargetLanguageRow = (event, index, targetLangIndex) => {
    let localMappings = JSON.parse(JSON.stringify(preConfiguredMappings));
    let sourceSelection = localMappings[index];
    let targerMapping = sourceSelection.targetAssetMappings[targetLangIndex];
    let newTargetMappings = sourceSelection.targetAssetMappings.filter(mapping => mapping !== targerMapping)
    sourceSelection.targetAssetMappings = newTargetMappings;
    setPreConfiguredMappings(localMappings);
  }

  const openHeaderOrFooterAssets = (isTargetLanguage, assetType, index, targetLangIndex) => {
    if (!validateAssetTypesAndLangs(isTargetLanguage, index, targetLangIndex)) {
      return;
    }
    //reset Tree on tree Loading
    dispatch(resetTree());
    let sourceSelection = [];
    if(preConfiguredMappings[index]?.externalId!==null && targetLangIndex===undefined)
    {
      let source = {
        "id" :preConfiguredMappings[index]?.externalId,
       "name":preConfiguredMappings[index]?.name,
       "checked": true,
       "type":preConfiguredMappings[index]?.assetType,
      };
      sourceSelection.push(source);
    }
    else if(preConfiguredMappings[index]?.targetAssetMappings[targetLangIndex]?.externalId!==undefined && targetLangIndex!==undefined )
    {
      sourceSelection = [];
      let source = {
        "id" :preConfiguredMappings[index]?.targetAssetMappings[targetLangIndex]?.externalId,
       "name":preConfiguredMappings[index]?.targetAssetMappings[targetLangIndex]?.name,
       "checked": true,
       "type":preConfiguredMappings[index]?.targetAssetMappings[targetLangIndex]?.assetType,
      };
      sourceSelection.push(source);
    }
    document.body.classList.add("modal-open");
    dispatchDataToTreeSliceRedux("displayName", "name");
    dispatchDataToTreeSliceRedux("contentType", "Eloqua");
    dispatchDataToTreeSliceRedux("isTreeLoading", true);
    dispatchDataToTreeSliceRedux("assetType",assetType);
    if(sourceSelection.length>0){
      dispatch(setSelectedTreeData(sourceSelection));
    } 
    setShowHeaderFooterTree(true);
    assetTypeRef.current = assetType;
    sourceAssetIndexRef.current = index;
    targetAssetIndexRef.current = targetLangIndex;
    getHeaderOrFooterAssets("root", null, setHeaderOrFooterAssets);
  }

  const validateAssetTypesAndLangs = (isTargetLanguage, index, targetLangIndex) => {
    let sourceSelection = preConfiguredMappings[index];
    let targetSelection = sourceSelection.targetAssetMappings[targetLangIndex]
    let isOk = true;
    if (sourceSelection.assetType === null && sourceSelection.language === null) {
      sourceSelection.error.assetTypeError = "Please Select Asset Type"
      sourceSelection.error.sourceLanguageError  = "Please Select Source Language"
      isOk = false
    }
    if (isTargetLanguage && targetSelection.language === null) {
      sourceSelection.error.targetLanguageError  = "Please Select Target Language"
      isOk = false
    }
    setPreConfiguredMappings(preConfiguredMappings);
    setMappingErrorMessage(mappingErrorMessage);
    return isOk;
  }

  const changeAsset = () => {
    if (selectedTreeData.length > 0) {
      let treeNode = selectedTreeData[0];
      if (targetAssetIndexRef.current >= 0) {
        let targetAssetMapping = preConfiguredMappings[sourceAssetIndexRef.current].targetAssetMappings[targetAssetIndexRef.current];
        targetAssetMapping.name = treeNode[treeValueRedux.displayName];
        targetAssetMapping.externalId = treeNode.id;
      } else {
        let sourceSelection = preConfiguredMappings[sourceAssetIndexRef.current];
        sourceSelection.name = treeNode[treeValueRedux.displayName];
        sourceSelection.externalId = treeNode.id;
      }
      closeHeaderOrFooterAssets();
    }
  }

  useEffect(() => {
    let folderId = treeValueRedux.selectedTreeNode?.id;
    if (folderId) {
      getHeaderOrFooterAssets(folderId, null, setChildData);
    }
  }, [treeValueRedux.selectedTreeNode])

  useEffect(() => {
    if (Array.isArray(childData) && childData.length > 0) {
      let cloneNode = JSON.parse(JSON.stringify(treeValueRedux.selectedTreeNode))
      cloneNode.children = childData;
      dispatch(addChildrenToTreeData(cloneNode))
    }
  }, [childData])

  useEffect(() => {
    let folderId;
    if (treeValueRedux.searchText?.length == 0) {
      folderId = 'root'
    } 
    getHeaderOrFooterAssets(folderId, treeValueRedux.searchText, setHeaderOrFooterAssets);
  }, [treeValueRedux.searchText])

  const closeHeaderOrFooterAssets = () => {
    jQuery("#addAsset").trigger('focus')
    document.body.classList.remove("modal-open");
    setShowHeaderFooterTree(false);
  }

  const onImageFormatChange = (e) => {
    let el = jQuery(e.target);
    let dataPref = el.attr('data-pref');
    let value = "" + el.is(':checked');
    let dataToSave = {
      "id": -1, 
      "preference": dataPref, 
      "status": value
    }
    putAxiosResponse(APIUrls.CUSTOMER_ORG_PREFERENCE, dataToSave
      ).then(res => {
        if (res.data.code === 200) {
          setSuccessMessage("Image format change updated successfully.");
          getOrgPreferences();
        }
      }).catch(err => {

      })
  }

  const saveAssetMapping = () => {
    let isOk = true;
    if (preConfiguredMappings?.length > 0) {
      preConfiguredMappings.map((mapping, index) => {
        if (mapping.error === undefined){
          mapping.error = {assetTypeError:null, assetNameError:null, sourceLanguageError:null, targetLanguageError:null};
        }

        if (mapping.assetType === null) {
          mapping.error.assetTypeError = translate("other_integrations_project_creation.asset_type_error");
          isOk = false;
        }
        if (mapping.language === null) {
          mapping.error.sourceLanguageError = translate("other_integrations_project_creation.source_lang-error");
          isOk = false;
        }
        if (mapping.name === null || mapping.externalId === null) {
          mapping.error.assetNameError = translate("other_integrations_project_creation.asset_error");
          isOk = false;
        }
        if (mapping.targetAssetMappings?.length == 0) {
          mapping.error.targetLanguageError = translate("other_integrations_project_creation.target_error");
          isOk = false;
        }
        mapping.targetAssetMappings.map((targetMapping, targetLangIndex) => {
          if (targetMapping.assetType === null && mapping.assetType === null) {
            mapping.error.assetTypeError = translate("other_integrations_project_creation.select_asset_type_error");
            isOk = false;
          }
          if (targetMapping.language === null) {
            targetMapping.targetLanguageError = translate("other_integrations_project_creation.select_target_lang_error");
            
            isOk = false;
          }
          if (targetMapping.name === null || targetMapping.externalId === null) {
            mapping.error.assetNameError = translate("other_integrations_project_creation.asset_in_target_error");
            isOk = false;
          }
        })
      })
      
    }
    let localAssetMappings = JSON.parse(JSON.stringify(preConfiguredMappings))
      setPreConfiguredMappings(localAssetMappings)
      if (isOk) {
        setSuccessMessage("Updating Eloqua Email Header Footer Mapping...")
        postAxiosResponse(APIUrls.ELOQUA_PRECONFIGURED_ASSET_MAPPING, preConfiguredMappings
        ).then(res => {
          if (res.data.code === 200) {
            setSuccessMessage("Eloqua Email Header Footer Mapping updated successfully.")
            setMappingErrorMessage({});
            //navigate("/settings");
          } else {
            setSuccessMessage(Constants.BLANK)
          }
        }).catch(err => {
          handleError(err);
          setSuccessMessage(Constants.BLANK)
        })
      }
  }

  const onSearchContactSubmit = (event) => {
    if (searchContactRef.current.value.length >= 3 ) {
      setPendingContacts(true);
      const dateTimestamp = dateConvertToTimeStamp();
      getAxiosResponse(APIUrls.ELOQUA_CONTACT_LIST + `?searchTerm=${searchContactRef.current.value}&page=1&_=${dateTimestamp}`
      ).then(res => {
        setPendingContacts(false);
        if (res.data.code === 200) {
          setContacts(res.data.data.body.result);
        }
      }).catch(err => {
        handleError(err)
      })
      
    }
  }

  const submitCredential = () => {
    if(!validateCredential()) {
      return;
    }
    setSuccessMessage("Validating credentials...")
    var isPost = true;
    setValidating(true);
  
    credentialData.credentials = {
      USERNAME : jQuery.trim(jQuery("#eloqua-username-input").val()),
      COMPANY_NAME : jQuery.trim(jQuery("#eloqua-company-name-input").val())  
    }
    credentialData.credentialsType = "ELOQUA"
    credentialData.credentialCharArray = jQuery.trim(jQuery("#eloqua-password-input").val());
    if(credentialData?.id){
      isPost = false;
    }
    putOrPostAxiosResponse(
      APIUrls.CUSTOMER_EXTERNAL_SERVICE_CREDENTIALS(Constants.ELOQUA), credentialData, isPost
      ).then((res) => {
        setValidating(false);
        setSuccessMessage(Constants.BLANK)
        if (res.data?.handledMessage || res.data?.data?.handledMessage){
          credentialErrorMessage.serverError = res.data?.handledMessage;
        } else {
          setServerErrorMessage([]);
          setSuccessMessage("Credential successfully updated!")
        }
      }).catch((err) => {
        setValidating(false);
        const errorMessage = "err - ";
        logError(errorMessage, err);        
         setSuccessMessage(Constants.BLANK)
      })
  }

  const validateCredential = () => {
    setCredentialErrorMessage(null);
    let isOk = true;
    if (jQuery.trim(jQuery("#eloqua-company-name-input").val()) == ""){
      credentialErrorMessage.companyName = "Please enter company name for Eloqua.";
      isOk = false;
    } 
    if (jQuery.trim(jQuery("#eloqua-username-input").val()) == ""){
      credentialErrorMessage.username = "Please enter username for Eloqua.";
      isOk = false;
    }  
    if (jQuery.trim(jQuery("#eloqua-password-input").val()) == ""){
      credentialErrorMessage.password = "Please enter password for Eloqua.";
      isOk = false;
    } 
    setCredentialErrorMessage(credentialErrorMessage)
    return isOk;
  }

  const clopseExpandAccordion = (accordion) => {
    if (accordion.hasClass("open")) {
      accordion.removeClass("open")
    } else {
      accordion.addClass("open")
    }
  }

  const close = () => {
    navigate("/settings")
  }

  const handleSort = async (column, sortDirection) => {
    $(".rdt_TableCol_Sortable[data-column-id='" + column.id + "']")
      .attr({ 'aria-label': column.name, 'aria-sort': sortDirection.toUpperCase() === Constants.DESC ? Constants.DESCENDING : Constants.ASCENDING });
  };
 
    $(document).ready(function(){
     $(".rdt_Table .rdt_TableCol span").attr("aria-hidden","true"); 
     $(".rdt_TableCol .rdt_TableCol_Sortable[disabled]").attr("tabIndex","-1"); 
    })

  const crumbs = [
    {label:'Settings', url:'settings'},
    {label:'Eloqua Integration', url:''},
  ];
  const showSelectable=(row)=>
  {
    return row?.id===contact?.id
  }

  return (
    <>
    <div className={isValidating ? "gb-overlay show" : "gb-overlay hide"}>
      <div className="gb-loader">
          <RotatingLines
            strokeColor="#0096FF"
            strokeWidth="5"
            width="196"
            visible={true}
          />
        </div>
      </div> 
    {(successMessage!==undefined && successMessage !== Constants.BLANK)?<SuccessMessage message={successMessage}/>:Constants.BLANK}
    
    <div className="body bg-color">
      <div id="container" className="dashboard-wrapper">
        <Header ref={scrollRef} />
        <LeftNavbar />
        <section className="dashboard-content" ref={scrollRef}>
          <div id="content" className="dashboard-wrap">
             <Breadcrumb crumbs={ crumbs } />
             <div className="project-setting-page">
                <div className="project-heading userprofile-heading">
                    <BackToSetting />
                    <h3 className="flex">Eloqua Integration</h3>
                    <span>Browse, manage and send your Eloqua assets to translation.</span>
                 </div>
                <div className="white-bg"> 
                <div className="integration-tab-content marketo-integration-accordion">
                <ConditionalBlock condition={preference==="true"}>
                {roleArray.includes ("ROLE_CUSTOMER")  ? (
                    <div id="permissions-accordion" className="integration-accordion-list open">
                      <div className="accordion-heading flex">
                        <div className="left">
                          <strong>User Permissions</strong>
                        </div>
                        <div className="right" onClick={() => clopseExpandAccordion(jQuery("#permissions-accordion"))}>
                           <svg className="plus-circle" xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
                             <circle cx="13" cy="13" r="12.3" fill="#F9FBFF" stroke="#1D4ED8" strokeWidth="1.4"/>
                             <rect x="12.2773" y="6.5" width="1.44444" height="13" rx="0.722222" fill="#1D4ED8"/>
                             <rect x="6.5" y="13.7227" width="1.44444" height="13" rx="0.722222" transform="rotate(-90 6.5 13.7227)" fill="#1D4ED8"/>
                            </svg>
                            <svg className="minus-circle" xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
                             <circle cx="13" cy="13" r="12.3" fill="#F9FBFF" stroke="#1D4ED8" strokeWidth="1.4"/>
                             <rect x="6.5" y="13.7227" width="1.44444" height="13" rx="0.722222" transform="rotate(-90 6.5 13.7227)" fill="#1D4ED8"/>
                            </svg>
                        </div>
                      </div>
                      <div className="integration-accordion-content">
                       <p>Manage who has permission to create Eloqua integration projects in OPAL-Marketing.</p>
                        <UserPermissionsSettingMemo 
                          settingType = {Constants.ELOQUA}
                          accessName = "Access To Eloqua"
                          integrationUsers={integrationUsers}
                          pendingPermission={pendingPermission}
                          getUser={getUser}
                          setPermissionStatus={setPermissionStatus}
                        />
                      </div>
                    </div>
                  ) : null}
                  </ConditionalBlock>
                {roleArray.includes ("ROLE_CUSTOMER")  ? (
                    <div id="department-accordion" className="integration-accordion-list open">
                      <div className="accordion-heading flex">
                        <div className="left">
                          <strong>Department Settings</strong>
                        </div>
                        <div className="right" onClick={() => clopseExpandAccordion(jQuery("#department-accordion"))}>
                           <svg className="plus-circle" xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
                             <circle cx="13" cy="13" r="12.3" fill="#F9FBFF" stroke="#1D4ED8" strokeWidth="1.4"/>
                             <rect x="12.2773" y="6.5" width="1.44444" height="13" rx="0.722222" fill="#1D4ED8"/>
                             <rect x="6.5" y="13.7227" width="1.44444" height="13" rx="0.722222" transform="rotate(-90 6.5 13.7227)" fill="#1D4ED8"/>
                            </svg>
                            <svg className="minus-circle" xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
                             <circle cx="13" cy="13" r="12.3" fill="#F9FBFF" stroke="#1D4ED8" strokeWidth="1.4"/>
                             <rect x="6.5" y="13.7227" width="1.44444" height="13" rx="0.722222" transform="rotate(-90 6.5 13.7227)" fill="#1D4ED8"/>
                            </svg>
                        </div>
                      </div>
                      <div className="integration-accordion-content">
                       <div className="datatable-block custom_pagination">
                       <DataTable 
                            columns={deptSettingsColumns}
                            data={settings} 
                            highlightOnHover
                            responsive
                            striped
                            selectableRowsHighlight={true}
                            defaultSortFieldId={1}
                            theme={theme}
                            progressPending={pendingDeptSettings}
                            onSort={handleSort}
                          />
                        </div>
                        {/* <div className="flex flex-end mar-top30">
                           <button className="blue-btn active">Save</button>
                        </div> */}
                      </div>
                    </div> 
                  ) : null}
                    {user?.permissions[Constants.ELOQUA_ACCESS] === true && 
                    <div id="integration-settings-accordion" className="integration-accordion-list open">
                      <div className="accordion-heading flex">
                        <div className="left">
                          <strong>Eloqua Integration Settings</strong>
                        </div>
                        <div className="right" onClick={() => clopseExpandAccordion(jQuery("#integration-settings-accordion"))}>
                           <svg className="plus-circle" xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
                             <circle cx="13" cy="13" r="12.3" fill="#F9FBFF" stroke="#1D4ED8" strokeWidth="1.4"/>
                             <rect x="12.2773" y="6.5" width="1.44444" height="13" rx="0.722222" fill="#1D4ED8"/>
                             <rect x="6.5" y="13.7227" width="1.44444" height="13" rx="0.722222" transform="rotate(-90 6.5 13.7227)" fill="#1D4ED8"/>
                            </svg>
                            <svg className="minus-circle" xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
                             <circle cx="13" cy="13" r="12.3" fill="#F9FBFF" stroke="#1D4ED8" strokeWidth="1.4"/>
                             <rect x="6.5" y="13.7227" width="1.44444" height="13" rx="0.722222" transform="rotate(-90 6.5 13.7227)" fill="#1D4ED8"/>
                            </svg>
                        </div>
                      </div>
                      <div className="integration-accordion-content">
                         <p className="f14-para">Please log in to your Eloqua account to access your marketing assets through OPAL-Marketing.</p>
                        <p>Once you have logged in, you will be able to see all of your Eloqua assets and automate their translation.</p>
                        <p><a target="_blank" href="https://cloudwords.zendesk.com/hc/en-us/sections/201345803-Eloqua">Learn More about Eloqua Integration</a></p>
                        <span className="error">{credentialErrorMessage.serverError}</span>
                          <EloquaCredentialMemo 
                            credentialData = {credentialData} 
                            errorMessages = {serverErrorMessage}
                            isValidating = {isValidating}
                            successMessage = {successMessage}
                            closePopup = {hideCredentialModel}
                            enableCredential = {setEnableCredential} 
                          />
                          <div className="flex flex-end mar-top20">
                            <button id="validateEloquaCred" className="blue-btn active" onClick={() => submitCredential()}>Validate</button>
                          </div>
                      </div>
                    </div>
                    }
                {roleArray.includes ("ROLE_CUSTOMER")  ? (
                    <div id="contact-accordion" className="integration-accordion-list open">
                      <div className="accordion-heading flex">
                        <div className="left">
                          <strong>Eloqua Preview Contact</strong>
                        </div>
                        <div className="right" onClick={() => clopseExpandAccordion(jQuery("#contact-accordion"))}>
                           <svg className="plus-circle" xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
                             <circle cx="13" cy="13" r="12.3" fill="#F9FBFF" stroke="#1D4ED8" strokeWidth="1.4"/>
                             <rect x="12.2773" y="6.5" width="1.44444" height="13" rx="0.722222" fill="#1D4ED8"/>
                             <rect x="6.5" y="13.7227" width="1.44444" height="13" rx="0.722222" transform="rotate(-90 6.5 13.7227)" fill="#1D4ED8"/>
                            </svg>
                            <svg className="minus-circle" xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
                             <circle cx="13" cy="13" r="12.3" fill="#F9FBFF" stroke="#1D4ED8" strokeWidth="1.4"/>
                             <rect x="6.5" y="13.7227" width="1.44444" height="13" rx="0.722222" transform="rotate(-90 6.5 13.7227)" fill="#1D4ED8"/>
                            </svg>
                        </div>
                      </div>
                      <div className="integration-accordion-content">
                        <p>OneReview displays Eloqua assets through a specific Eloqua contact. Select the Eloqua contact through which you would like to preview your assets.</p>
                        <div className="multiselect-output flex">
                        {contact && 
                        <button onClick={(e)=>clearContact(e)}>
                          <strong>{contact.emailAddress}</strong>
                          <svg xmlns="http://www.w3.org/2000/svg" width="10" height="9" viewBox="0 0 10 9" fill="none">
                            <path d="M1.50391 7.99067L4.99924 4.49533M8.49457 1L4.99857 4.49533M4.99857 4.49533L1.50391 1M4.99924 4.49533L8.49457 7.99067" stroke="#213248" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                          </svg>
                          </button>
                        }             
                        </div>
                        <div className="flex justify-end">
                          <button className="blue-btn active" onClick=
                            {handleSelectContactClick}
                            >Select Contact  </button>
                       </div>
                      </div>
                    </div>
                  ) : null}
                {roleArray.includes ("ROLE_CUSTOMER")  ? (
                    <div id="image-accordion" className="integration-accordion-list open">
                      <div className="accordion-heading flex">
                        <div className="left">
                          <strong>Supported Image Formats</strong>
                        </div>
                        <div className="right" onClick={() => clopseExpandAccordion(jQuery("#image-accordion"))}>
                           <svg className="plus-circle" xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
                             <circle cx="13" cy="13" r="12.3" fill="#F9FBFF" stroke="#1D4ED8" strokeWidth="1.4"/>
                             <rect x="12.2773" y="6.5" width="1.44444" height="13" rx="0.722222" fill="#1D4ED8"/>
                             <rect x="6.5" y="13.7227" width="1.44444" height="13" rx="0.722222" transform="rotate(-90 6.5 13.7227)" fill="#1D4ED8"/>
                            </svg>
                            <svg className="minus-circle" xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
                             <circle cx="13" cy="13" r="12.3" fill="#F9FBFF" stroke="#1D4ED8" strokeWidth="1.4"/>
                             <rect x="6.5" y="13.7227" width="1.44444" height="13" rx="0.722222" transform="rotate(-90 6.5 13.7227)" fill="#1D4ED8"/>
                            </svg>
                        </div>
                      </div>
                      <div className="integration-accordion-content">
                         <p className="f14-para">Select which image formats are allowed as source files for Eloqua projects</p>
                         <div className="form-check small-checkbox">
                            <input className="form-check-input" type="checkbox" name="chkbox" id="chk222" 
                            data-pref="ELOQUA_IMAGE_ACCEPT_AI_FORMAT" onChange={(e) => onImageFormatChange(e)}
                            disabled={(orgPreferences?.ELOQUA_IMAGE_ACCEPT_POSTSCRIPT_FORMAT?.status==="false"  &&
                                      orgPreferences?.ELOQUA_IMAGE_ACCEPT_PHOTOSHOP_FORMAT?.status==="false" &&
                                      orgPreferences?.ELOQUA_IMAGE_ACCEPT_SVG_FORMAT?.status==="false")?true:false}
                            checked ={orgPreferences?.ELOQUA_IMAGE_ACCEPT_AI_FORMAT?.status==="true"}
                            />
                            <label className="form-check-label" for="chk222">Adobe Illustrator (.ai)</label>
                         </div>  
                         <div className="form-check small-checkbox">
                            <input className="form-check-input" type="checkbox" name="chkbox" id="chk223" 
                            data-pref="ELOQUA_IMAGE_ACCEPT_POSTSCRIPT_FORMAT" onChange={(e) => onImageFormatChange(e)}
                            disabled={(orgPreferences?.ELOQUA_IMAGE_ACCEPT_AI_FORMAT?.status==="false"  &&
                                      orgPreferences?.ELOQUA_IMAGE_ACCEPT_PHOTOSHOP_FORMAT?.status==="false" &&
                                      orgPreferences?.ELOQUA_IMAGE_ACCEPT_SVG_FORMAT?.status==="false")?true:false}
                            checked ={orgPreferences?.ELOQUA_IMAGE_ACCEPT_POSTSCRIPT_FORMAT?.status === "true"} />
                            <label className="form-check-label" for="chk223">Postscript/Encapsulated Postscript (.ps, .eps)</label>
                         </div> 
                         <div className="form-check small-checkbox">
                            <input className="form-check-input" type="checkbox" name="chkbox" id="chk224" 
                            data-pref="ELOQUA_IMAGE_ACCEPT_PHOTOSHOP_FORMAT" onChange={(e) => onImageFormatChange(e)}
                            disabled={(orgPreferences?.ELOQUA_IMAGE_ACCEPT_AI_FORMAT?.status==="false"  &&
                                      orgPreferences?.ELOQUA_IMAGE_ACCEPT_POSTSCRIPT_FORMAT?.status==="false" &&
                                      orgPreferences?.ELOQUA_IMAGE_ACCEPT_SVG_FORMAT?.status==="false")?true:false}
                            checked ={orgPreferences?.ELOQUA_IMAGE_ACCEPT_PHOTOSHOP_FORMAT?.status === "true"} />
                            <label className="form-check-label" for="chk224">Photoshop (.psd)</label>
                         </div> 
                         <div className="form-check small-checkbox">
                            <input className="form-check-input" type="checkbox" name="chkbox" id="chk225" 
                            data-pref="ELOQUA_IMAGE_ACCEPT_SVG_FORMAT" onChange={(e) => onImageFormatChange(e)}
                            disabled={(orgPreferences?.ELOQUA_IMAGE_ACCEPT_AI_FORMAT?.status==="false"  &&
                                      orgPreferences?.ELOQUA_IMAGE_ACCEPT_POSTSCRIPT_FORMAT?.status==="false" &&
                                      orgPreferences?.ELOQUA_IMAGE_ACCEPT_PHOTOSHOP_FORMAT?.status==="false")?true:false}
                            checked ={orgPreferences?.ELOQUA_IMAGE_ACCEPT_SVG_FORMAT?.status === "true"} />
                            <label className="form-check-label" for="chk225">Scalable Vector Graphics (.svg)</label>
                         </div> 
                      </div>
                    </div>
                    ) : null}
                {roleArray.includes ("ROLE_CUSTOMER")  ? (
                    <div id="mapping-accordion" className="integration-accordion-list open">
                      <div className="accordion-heading flex">
                        <div className="left">
                          <strong>Configure Eloqua Email Header Footer Mapping</strong>
                        </div>
                        <div className="right" onClick={() => clopseExpandAccordion(jQuery("#mapping-accordion"))}>
                           <svg className="plus-circle" xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
                             <circle cx="13" cy="13" r="12.3" fill="#F9FBFF" stroke="#1D4ED8" strokeWidth="1.4"/>
                             <rect x="12.2773" y="6.5" width="1.44444" height="13" rx="0.722222" fill="#1D4ED8"/>
                             <rect x="6.5" y="13.7227" width="1.44444" height="13" rx="0.722222" transform="rotate(-90 6.5 13.7227)" fill="#1D4ED8"/>
                            </svg>
                            <svg className="minus-circle" xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
                             <circle cx="13" cy="13" r="12.3" fill="#F9FBFF" stroke="#1D4ED8" strokeWidth="1.4"/>
                             <rect x="6.5" y="13.7227" width="1.44444" height="13" rx="0.722222" transform="rotate(-90 6.5 13.7227)" fill="#1D4ED8"/>
                            </svg>
                        </div>
                      </div>
                      <div className="integration-accordion-content">
                         <p className="f14-para">
                           This configuration allows the appropriate headers and footers to be used when an email is translated.
                           <div><strong>Step 1:</strong> Select the source language header or footer.</div>
                           <div> <strong>Step 2:</strong> Select the header or footer for each target language.</div>
                         </p>
                         <p className="f14-para">
                          For example, lets say you have a English email with a footer containing your company address in US. If you need to translate this email in French but want the translated french email to use your company's address in France, then you need to map below the English email
                          footer containing US address to French email footer containing French address.
                         </p>
                         <div>
                         {mappingErrorMessage.length > 0 &&
                            <><span id="eloquaPreConfigureError" className="error">
                            {Object.entries(mappingErrorMessage).map(([key, error]) => {
                              return (<li>{JSON.stringify(error)}</li>) 
                            })}
                            </span><br/></>
                          }
                         </div>
                         <div className="table-responsive global-table configure-eloqua">
                          <table className="sortable">
                            <thead>
                                <th>Asset Type</th>
                                <th>Source Language</th>
                                <th><div>Target Language</div></th>
                                 <th></th>
                            </thead>
                            <tbody>
                              {preConfiguredMappings?.map((preConfiguredMapping, index) => {
                                return (<tr>
                                  <td>
                                    <span className="error">{preConfiguredMapping.error?.assetTypeError}</span>
                                    <div className="flex-center wrap-dropdown">
                                      <div className="global-dropdown-block mr-12">
                                        <Select className="global-dropdown-select" 
                                          menuShouldScrollIntoView={false}
                                          closeMenuOnSelect={true}
                                          classNamePrefix='cw'
                                          defaultValue={1} 
                                          data-index={index} 
                                          aria-label="Select asset type"
                                          options={assetTypeOptions}
                                          value={assetTypeOptions.filter(function (option) {
                                             return option.value === preConfiguredMapping.assetType;
                                          })}
                                          onChange={e => onChangeAssetType(e, index)}
                                          
                                        />
                                      </div>
                                    </div>
                                  </td>

                                  <td>
                                    <span className="error">{preConfiguredMapping.error?.sourceLanguageError}</span>
                                    <div className="flex-center wrap-dropdown">
                                      <div className="global-dropdown-block mr-12">
                                        <Select className="global-dropdown-select" 
                                          menuShouldScrollIntoView={false}
                                          closeMenuOnSelect={true}
                                          classNamePrefix='cw'
                                          aria-label="Select Source Language"
                                          defaultValue={1}
                                          options={sourceLanguageOptions} 
                                          value={sourceLanguageOptions.filter(function (option) {
                                            return option.language === preConfiguredMapping.language;
                                          })}
                                          onChange={e => onChangeSourceLanguage(e, index)}
                                        />
                                      </div>
                                      <div className="flex-center sourch-relative">
                                        <div className={(preConfiguredMapping.assetType === null || Object.keys(preConfiguredMapping.assetType).length === 0) ? "mr-12 select-lang hide" : "mr-12 select-lang"}>
                                          {preConfiguredMapping.name ? 
                                          <>
                                          {preConfiguredMapping.name} {preConfiguredMapping.externalId}
                                           <button className="sourch-change" onClick={() => openHeaderOrFooterAssets(false, preConfiguredMapping.assetType, index)}>
                                            <svg className="aaa-change-icon" xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none"><path d="M0.25 15.25H17.75V16.5H0.25V15.25ZM14.875 4.625C15.375 4.125 15.375 3.375 14.875 2.875L12.625 0.625C12.125 0.125 11.375 0.125 10.875 0.625L1.5 10V14H5.5L14.875 4.625ZM11.75 1.5L14 3.75L12.125 5.625L9.875 3.375L11.75 1.5ZM2.75 12.75V10.5L9 4.25L11.25 6.5L5 12.75H2.75Z" fill="#1D4ED8"></path></svg>
                                          </button>
                                          </>
                                          :
                                          preConfiguredMapping.language && 
                                            <Link onClick={() => openHeaderOrFooterAssets(false, preConfiguredMapping.assetType, index)}>Select</Link>
                                        }
                                          
                                        </div>
                                      </div>
                                    </div>
                                  </td>
                                  
                                  <td>
                                    <div>
                                      <div>
                                       <button id={"addTargetLanguage-"+{index}} className="blue-btn active" aria-label="Add Target Language" data-index={index}
                                       onClick={e => addMoreTargetLanguages(e)}
                                       disabled={preConfiguredMapping.language === null || Object.keys(preConfiguredMapping.language).length === 0 || preConfiguredMapping.assetType === null || Object.keys(preConfiguredMapping.assetType).length === 0} >Add Target Language</button>
                                       </div>
                                        {preConfiguredMapping?.targetAssetMappings?.map((targetAssetMapping, targetLangIndex) => {
                                          return(
                                            <>
                                            <br /><span className="error">{targetAssetMapping.targetLanguageError}</span>
                                            <div className="flex-center wrap-dropdown">
                                              <div className="global-dropdown-block mb-0 mr-12">
                                              <Select className="global-dropdown-select" 
                                                menuShouldScrollIntoView={false}
                                                closeMenuOnSelect={true}
                                                classNamePrefix='cw'
                                                aria-label="Select Target Language"
                                                data-index={index}
                                                target-index={targetLangIndex}
                                                defaultValue={1}
                                                options={targetLanguageOptions} 
                                                value={targetLanguageOptions.filter(function (option) {
                                                  return option.language === targetAssetMapping.language;
                                                })}
                                                onChange={e => onChangeTargetLanguage(e, index, targetLangIndex)}
                                              />
                                              </div>
                                              <div className="flex-center sourch-relative">
                                                <div className={(targetAssetMapping.assetType === null || Object.keys(preConfiguredMapping.assetType).length === 0) ? "mr-12 select-lang hide" : "mr-12 select-lang"}>
                                                {targetAssetMapping.name ? 
                                                  <>
                                                  {targetAssetMapping?.name} {targetAssetMapping.externalId}
                                                  <button  className="sourch-change" onClick={() => openHeaderOrFooterAssets(true, targetAssetMapping.assetType, index, targetLangIndex)}>
                                                     <svg className="aaa-change-icon" xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none"><path d="M0.25 15.25H17.75V16.5H0.25V15.25ZM14.875 4.625C15.375 4.125 15.375 3.375 14.875 2.875L12.625 0.625C12.125 0.125 11.375 0.125 10.875 0.625L1.5 10V14H5.5L14.875 4.625ZM11.75 1.5L14 3.75L12.125 5.625L9.875 3.375L11.75 1.5ZM2.75 12.75V10.5L9 4.25L11.25 6.5L5 12.75H2.75Z" fill="#1D4ED8"></path></svg>
                                                  </button>
                                                  </>
                                                  :
                                                  targetAssetMapping.language && 
                                                    <Link onClick={() => openHeaderOrFooterAssets(true, targetAssetMapping.assetType, index, targetLangIndex)}>Select</Link>
                                                }
                                                </div>
                                                <button id={"deleteTargetLanguage-"+{index} + {targetLangIndex}} className="inline-flex" aria-label="delete" 
                                                  data-index={index} target-index={targetLangIndex} onClick = {e => removeTargetLanguageRow(e, index, targetLangIndex)}
                                                >
                                                  <svg className="aaa-change-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 21 21" fill="none">
                                                    <path d="M17.9242 17.9242C15.94 19.9085 13.3062 21 10.5 21C7.69381 21 5.05997 19.9085 3.07576 17.9242C1.09154 15.94 0 13.3062 0 10.5C0 7.69381 1.09154 5.05997 3.07576 3.07576C5.05997 1.09154 7.69381 0 10.5 0C13.3062 0 15.94 1.09154 17.9242 3.07576C19.9085 5.05997 21 7.69381 21 10.5C21 13.3062 19.9085 15.94 17.9242 17.9242ZM17.0802 3.91982C15.3213 2.16098 12.9836 1.19318 10.5 1.19318C8.01641 1.19318 5.67866 2.16098 3.91982 3.91982C0.291667 7.54798 0.291667 13.452 3.91982 17.0802C5.67866 18.839 8.01641 19.8068 10.5 19.8068C12.9836 19.8068 15.3213 18.839 17.0802 17.0802C20.7083 13.452 20.7083 7.54798 17.0802 3.91982Z" fill="#1D4ED8"/>
                                                    <path d="M15.1267 15.1271C14.8925 15.3613 14.5169 15.3613 14.2827 15.1271L10.4998 11.3442L6.71699 15.1271C6.48278 15.3613 6.10715 15.3613 5.87293 15.1271C5.63871 14.8929 5.63871 14.5172 5.87293 14.283L9.65576 10.5002L5.87293 6.71735C5.63871 6.48313 5.63871 6.1075 5.87293 5.87328C5.98783 5.75838 6.1425 5.69652 6.29275 5.69652C6.443 5.69652 6.59768 5.75397 6.71257 5.87328L10.4954 9.65611L14.2782 5.87328C14.3931 5.75838 14.5478 5.69652 14.6981 5.69652C14.8527 5.69652 15.003 5.75397 15.1179 5.87328C15.3521 6.1075 15.3521 6.48313 15.1179 6.71735L11.3439 10.5002L15.1267 14.283C15.3609 14.5172 15.3609 14.8929 15.1267 15.1271Z" fill="#1D4ED8"/>
                                                  </svg>
                                                </button>
                                              </div>
                                            </div>
                                            </>
                                          )
                                        })}
                                    </div>
                                  </td>

                                    <td>
                                    <button className="inline-flex" aria-label="delete" data-index={index} onClick={e => removeAssetRow(e)}>
                                          <svg className="aaa-change-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 21 21" fill="none">
                                           <path d="M11.0599 2.33973C11.3056 2.58546 11.4573 2.90766 11.4917 3.25039H8.50673C8.54117 2.90766 8.69283 2.58546 8.93856 2.33973C9.21986 2.05843 9.60139 1.90039 9.99922 1.90039C10.397 1.90039 10.7786 2.05843 11.0599 2.33973ZM7.94861 1.34978C7.44021 1.85818 7.14008 2.5359 7.1031 3.25039H1.74922C1.56357 3.25039 1.38552 3.32414 1.25424 3.45542C1.12297 3.58669 1.04922 3.76474 1.04922 3.95039C1.04922 4.13604 1.12297 4.31409 1.25424 4.44537C1.38552 4.57664 1.56357 4.65039 1.74922 4.65039H2.77494L4.07301 15.896C4.17007 16.7369 4.57287 17.5127 5.20477 18.0759C5.83666 18.6391 6.65356 18.9503 7.50001 18.9504H12.4984C13.3449 18.9503 14.1618 18.6391 14.7937 18.0759C15.4256 17.5127 15.8284 16.7369 15.9254 15.896L17.2235 4.65039H18.2492C18.4349 4.65039 18.6129 4.57664 18.7442 4.44537C18.8755 4.31409 18.9492 4.13604 18.9492 3.95039C18.9492 3.76474 18.8755 3.58669 18.7442 3.45542C18.6129 3.32414 18.4349 3.25039 18.2492 3.25039H12.8953C12.8584 2.5359 12.5582 1.85818 12.0498 1.34978C11.506 0.805925 10.7683 0.500391 9.99922 0.500391C9.23009 0.500391 8.49246 0.805925 7.94861 1.34978ZM6.13615 17.0311C5.76064 16.6966 5.52118 16.2358 5.46333 15.7362C5.46333 15.7362 5.46333 15.7362 5.46332 15.7361L4.18462 4.65039H15.8138L14.5351 15.7361C14.4773 16.2357 14.2378 16.6966 13.8623 17.0311C13.4868 17.3657 13.0014 17.5505 12.4984 17.5504H7.50002C6.99708 17.5505 6.51168 17.3657 6.13615 17.0311ZM8.84419 7.30542C8.71292 7.17414 8.53487 7.10039 8.34922 7.10039C8.16357 7.10039 7.98552 7.17414 7.85424 7.30542C7.72297 7.43669 7.64922 7.61474 7.64922 7.80039V14.4004C7.64922 14.586 7.72297 14.7641 7.85424 14.8954C7.98552 15.0266 8.16357 15.1004 8.34922 15.1004C8.53487 15.1004 8.71292 15.0266 8.84419 14.8954C8.97547 14.7641 9.04922 14.586 9.04922 14.4004V7.80039C9.04922 7.61474 8.97547 7.43669 8.84419 7.30542ZM12.3492 7.80039C12.3492 7.61474 12.2755 7.43669 12.1442 7.30542C12.0129 7.17414 11.8349 7.10039 11.6492 7.10039C11.4636 7.10039 11.2855 7.17414 11.1542 7.30542C11.023 7.43669 10.9492 7.61474 10.9492 7.80039V14.4004C10.9492 14.586 11.023 14.7641 11.1542 14.8954C11.2855 15.0266 11.4636 15.1004 11.6492 15.1004C11.8349 15.1004 12.0129 15.0266 12.1442 14.8954C12.2755 14.7641 12.3492 14.586 12.3492 14.4004V7.80039Z" fill="#1D4ED8" stroke="#1D4ED8" stroke-width="0.3"></path>
                                          </svg>
                                        </button>
                                        </td>

                                </tr>)
                               })}
                           </tbody>
                          </table>
                        </div>
                        <div className="flex justify-end btn-gap mar-top15">
                          <button id="addAsset" className="blue-btn" aria-label="Add Asset"
                           onClick={handleAddAssetClick}>Add Asset</button>
                          <button id="save-mapping" className="blue-btn active" aria-label="Save Asset" onClick={() => saveAssetMapping()} disabled={preConfiguredMappings.length===0}>Save</button>
                          
                        </div>
                      </div>
                    </div>
                    ) : null}
                  </div> 
                </div>
             </div>
          </div>
        </section>
      </div>
       
        {showContactPopup &&
          <div className="lightbox-panel target-lang-popup">
          <div className="inner-lightbox-panel pb-0">
          <div className="modal-header flex padd-lr">
            <strong>Select Eloqua Contact</strong>
            <button className="close" aria-label="close right popup" onClick={hideContactModel}>
            <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
              <path d="M17.9242 17.9242C15.94 19.9085 13.3062 21 10.5 21C7.69381 21 5.05997 19.9085 3.07576 17.9242C1.09154 15.94 0 13.3062 0 10.5C0 7.69381 1.09154 5.05997 3.07576 3.07576C5.05997 1.09154 7.69381 0 10.5 0C13.3062 0 15.94 1.09154 17.9242 3.07576C19.9085 5.05997 21 7.69381 21 10.5C21 13.3062 19.9085 15.94 17.9242 17.9242ZM17.0802 3.91982C15.3213 2.16098 12.9836 1.19318 10.5 1.19318C8.01641 1.19318 5.67866 2.16098 3.91982 3.91982C0.291667 7.54798 0.291667 13.452 3.91982 17.0802C5.67866 18.839 8.01641 19.8068 10.5 19.8068C12.9836 19.8068 15.3213 18.839 17.0802 17.0802C20.7083 13.452 20.7083 7.54798 17.0802 3.91982Z" fill="white"></path>
              <path d="M15.1267 15.1269C14.8925 15.3611 14.5169 15.3611 14.2827 15.1269L10.4998 11.3441L6.71699 15.1269C6.48278 15.3611 6.10715 15.3611 5.87293 15.1269C5.63871 14.8927 5.63871 14.517 5.87293 14.2828L9.65576 10.5L5.87293 6.71716C5.63871 6.48295 5.63871 6.10732 5.87293 5.8731C5.98783 5.7582 6.1425 5.69633 6.29275 5.69633C6.443 5.69633 6.59768 5.75378 6.71257 5.8731L10.4954 9.65593L14.2782 5.8731C14.3931 5.7582 14.5478 5.69633 14.6981 5.69633C14.8527 5.69633 15.003 5.75378 15.1179 5.8731C15.3521 6.10732 15.3521 6.48295 15.1179 6.71716L11.3439 10.5L15.1267 14.2828C15.3609 14.517 15.3609 14.8927 15.1267 15.1269Z" fill="white"></path>
            </svg>
           </button>
           </div>
           <div className="lightbox-content">
             <div className="gb-gray-list flex flex-align-center mar-bot16">
              <label className="mr-12" for="search-contact">Search: </label> 
              <input id="search-contact" type="text" className="form-control-sm width-auto" ref={searchContactRef} placeholder="Search" onChange={() => onSearchContactSubmit()} />
             </div>
             <div className="datatable-block custom_pagination">
                <DataTable 
                  columns={contactColumns}
                  data={contacts} 
                  highlightOnHover
                  responsive
                  striped
                  selectableRows
                  selectableRowsSingle
                  selectableRowsHighlight={true}
                  defaultSortFieldId={1}
                  theme={theme}
                  progressPending={pendingContacts}
                  onSelectedRowsChange={onContactSelect}
                  onSort={handleSort}
                  selectableRowSelected={showSelectable}


                />
              </div>
           </div>
           <div className="modal-footer modal-footer-border flex px-22">
              <button className="btn btn-bold first-focus" onClick={hideContactModel}>Cancel</button>
              <button className="btn btn-bold active" onClick={() => {if(selectedContactRef?.current?.id){saveSelectedContact()}}}>Save</button>
           </div>
          </div>	
        </div>
        }
        {showHeaderFooterTree &&
          <div className="lightbox-panel marketotree-lightbox-panel">
          <div className="inner-lightbox-panel pb-0">
            <div className="modal-header flex padd-lr">
              <strong>Eloqua Integration</strong>
              <button className="close" aria-label="close popup" onClick={closeHeaderOrFooterAssets}>
                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none"><path d="M17.9242 17.9242C15.94 19.9085 13.3062 21 10.5 21C7.69381 21 5.05997 19.9085 3.07576 17.9242C1.09154 15.94 0 13.3062 0 10.5C0 7.69381 1.09154 5.05997 3.07576 3.07576C5.05997 1.09154 7.69381 0 10.5 0C13.3062 0 15.94 1.09154 17.9242 3.07576C19.9085 5.05997 21 7.69381 21 10.5C21 13.3062 19.9085 15.94 17.9242 17.9242ZM17.0802 3.91982C15.3213 2.16098 12.9836 1.19318 10.5 1.19318C8.01641 1.19318 5.67866 2.16098 3.91982 3.91982C0.291667 7.54798 0.291667 13.452 3.91982 17.0802C5.67866 18.839 8.01641 19.8068 10.5 19.8068C12.9836 19.8068 15.3213 18.839 17.0802 17.0802C20.7083 13.452 20.7083 7.54798 17.0802 3.91982Z" fill="white"></path><path d="M15.1267 15.1269C14.8925 15.3611 14.5169 15.3611 14.2827 15.1269L10.4998 11.3441L6.71699 15.1269C6.48278 15.3611 6.10715 15.3611 5.87293 15.1269C5.63871 14.8927 5.63871 14.517 5.87293 14.2828L9.65576 10.5L5.87293 6.71716C5.63871 6.48295 5.63871 6.10732 5.87293 5.8731C5.98783 5.7582 6.1425 5.69633 6.29275 5.69633C6.443 5.69633 6.59768 5.75378 6.71257 5.8731L10.4954 9.65593L14.2782 5.8731C14.3931 5.7582 14.5478 5.69633 14.6981 5.69633C14.8527 5.69633 15.003 5.75378 15.1179 5.8731C15.3521 6.10732 15.3521 6.48295 15.1179 6.71716L11.3439 10.5L15.1267 14.2828C15.3609 14.517 15.3609 14.8927 15.1267 15.1269Z" fill="white"></path></svg>
              </button>
            </div>
            <div className="lightbox-content padd-22">
              <TreeViewMemo isElouquaSettingPage = "true" />
            </div>
            <div className="modal-footer modal-footer-border flex px-22">
               {!permissionStatus && <p className="textDanger">{Constants.PERMISSION}</p>}
                <button className="btn btn-bold" onClick={closeHeaderOrFooterAssets}>Cancel</button>
                {permissionStatus && <button className="btn btn-bold active" onClick={()=> changeAsset()}> Save</button>}

            </div>
          </div>
          </div>
        }
        <div className="stricy-btn flex flex-center no-rightlist justify-end">
        <div className="left flex">
            {/* <div>
             <button className="btn-default">Cancel</button>
            </div> */}
            <div>
            <button className="btn-default" onClick={() => close()}>Close</button>
            </div>
        </div>
     </div>
    </div>

    </>
  );
}
